import NodeTypesRegistry from './NodeTypesRegistry';

export {
    NodeTypesRegistry
};
